import React from 'react';
import { BouncingDotsLoader } from './BouncingDotsLoader';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';

interface TimelineLoadingStateProps {
  operatorCount?: number;
  className?: string;
}

export function TimelineLoadingState({
  operatorCount = 1,
  className = ''
}: TimelineLoadingStateProps) {
  const timeSlots = Array.from({ length: 17 }, (_, i) => i + 6);
  const { isMobile } = useResponsiveLayout();

  return (
    <div className={`bg-white rounded-lg border border-gray-200 overflow-hidden flex flex-col relative ${isMobile ? '' : 'h-full'} ${className}`}>
      {/* Loader overlay - always centered in the visible container */}
      <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
        <BouncingDotsLoader size="lg" />
      </div>

      {/* Scrollable skeleton content */}
      <div className={`${isMobile ? '' : 'flex-1 overflow-auto min-h-0'}`}>
        <div className="flex">
          <div className="w-20 border-r border-gray-200 flex-shrink-0">
            <div className="h-12 border-b border-gray-200 flex items-center justify-center">
              <div className="h-4 w-12 bg-gray-200 rounded animate-pulse" />
            </div>
            {timeSlots.map((hour) => (
              <div
                key={hour}
                className="h-16 border-b border-gray-100 flex items-start justify-center pt-1"
              >
                <div className="h-3 w-12 bg-gray-200 rounded animate-pulse" />
              </div>
            ))}
          </div>

          <div className="flex-1">
            {timeSlots.map((hour) => (
              <div
                key={hour}
                className="h-16 border-b border-gray-100"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function SkeletonTimeSlot() {
  return (
    <div className="h-16 border-b border-gray-100 flex items-start justify-center pt-1">
      <div className="h-3 w-12 bg-gray-200 rounded animate-pulse" />
    </div>
  );
}
